import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { useSEO } from "@/hooks/useSEO";

export default function NotFound() {
  useSEO({
    title: "Page not found | Glebe Park Dental",
    description:
      "Sorry, we couldn't find that page. Head back to the Glebe Park Dental homepage, browse our treatments, or get in touch — we're in Canberra City.",
    path: "/404",
    noindex: true,
  });

  return (
    <main className="bg-cream" data-testid="not-found-page">
      <Nav />
      <section className="flex min-h-[72vh] items-center">
        <div className="mx-auto max-w-2xl px-5 py-32 text-center sm:px-8">
          <p className="font-mono text-xs tracking-[0.3em] uppercase text-leafmute">Error 404</p>
          <h1 className="mt-5 font-serif text-4xl leading-[1.1] tracking-tight text-ink sm:text-5xl">
            We can't find that page.
          </h1>
          <p className="mt-6 font-sans text-base leading-relaxed text-fern">
            The page you were after may have moved or never existed. Here's where
            most people are heading:
          </p>
          <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/"
              data-testid="notfound-home-link"
              className="inline-flex items-center rounded-md bg-forest px-6 py-3 font-sans text-sm font-medium text-cream transition-colors duration-300 hover:bg-pine"
            >
              Back to home
            </Link>
            <Link
              to="/services"
              data-testid="notfound-services-link"
              className="inline-flex items-center rounded-md border border-ink/20 px-6 py-3 font-sans text-sm font-medium text-ink transition-colors duration-300 hover:border-forest hover:text-forest"
            >
              Our treatments
            </Link>
            <Link
              to="/contact"
              data-testid="notfound-contact-link"
              className="inline-flex items-center rounded-md border border-ink/20 px-6 py-3 font-sans text-sm font-medium text-ink transition-colors duration-300 hover:border-forest hover:text-forest"
            >
              Contact us
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
